import React, { useEffect, useImperativeHandle, useState } from "react";
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import { useScreenSize } from "../../utils/media-query";
import { ListinoDTO } from "../../data";
import ListiniAnimaliForm from "../../pages/listini/formsListini/ListiniAnimaliForm";
import AnimaliDettaglio from "../../pages/listini/dettagli/animaliDettaglio";
import { CollapsablePanel } from "../collapsablePanel/CollapsablePanel";
import ListiniPulciniForm from "../../pages/listini/formsListini/ListiniPulciniForm";
import PulciniDettaglio from "../../pages/listini/dettagli/pulciniDettaglio";
import ListiniMangimiForm from "../../pages/listini/formsListini/ListiniMangimiForm";
import MangimiDettaglio from "../../pages/listini/dettagli/mangimiDettaglio";

type Props = {
  listino?: ListinoDTO,
  tipoListino: string,
  onChange: () => void,
  readonly?: boolean
};

export type ListinoPopupHandle = {
  edit: (idListino: number) => void,
  new: (idFiliera: number) => void,
};

type State = {
  id?: number,
  idFiliera?: number,
  visible: boolean
};

const PopupListino: React.ForwardRefRenderFunction<ListinoPopupHandle, Props> = (props, ref) => {
  const [state, setState] = useState<State>({ id: undefined, idFiliera: undefined, visible: false });
  const [isChanged, setIsChanged] = useState<boolean>(false);
  const { isXSmall, isSmall } = useScreenSize();

  useImperativeHandle(ref, () => ({
    edit(idListino) {
      setState({ id: idListino, visible: true });
    },
    new(idFiliera) {
      setState({ idFiliera, visible: true });
    }
  }));

  const hidePopup = () => {
    if (isChanged) props.onChange();
    setState({ id: undefined, visible: false });
    setIsChanged(false);
  };

  const handleInserted = (newId: number) => {
    setState(prev => ({ ...prev, id: newId }));
    setIsChanged(true);
  };

  return (
    <Popup
      visible={state.visible}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={false}
      showTitle={false}
      fullScreen={true}
      onHidden={hidePopup}
      title="Listino"
      container=".dx-viewport"
    >
      <Position at="center" my="center" of="" collision="fit" />

      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="center"
        options={{
          text: 'Chiudi',
          onClick: hidePopup
        }}
      />

      {props.tipoListino === 'Animali' && (
        <>
          <CollapsablePanel title="Listini Animali - Testata">
            <ListiniAnimaliForm
              idListino={state.id}
              tipoListino={props.tipoListino}
              onUpdated={() => setIsChanged(true)}
              onInserted={handleInserted}
              readonly={props.readonly}
            />
          </CollapsablePanel>

          {state.id && (
            <CollapsablePanel title="Listini Animali Dettagli">
              <AnimaliDettaglio
                listino={props.listino!}
                idListino={state.id}
                onChanged={() => setIsChanged(true)}
                readonly={props.readonly}
              />
            </CollapsablePanel>
          )}
        </>
      )}

      {props.tipoListino === 'Pulcini' && (
        <>
          <CollapsablePanel title="Listini Pulcini - Testata">
            <ListiniPulciniForm
              idListino={state.id}
              tipoListino={props.tipoListino}
              onUpdated={() => setIsChanged(true)}
              onInserted={handleInserted}
              readonly={props.readonly}
            />
          </CollapsablePanel>

          {state.id && (
            <CollapsablePanel title="Listini Pulcini Dettagli">
              <PulciniDettaglio
                listino={props.listino!}
                idListino={state.id}
                onChanged={() => setIsChanged(true)}
                readonly={props.readonly}
              />
            </CollapsablePanel>
          )}
        </>
      )}

      {props.tipoListino === 'Mangimi' && (
        <>
          <CollapsablePanel title="Listini Mangimi - Testata">
            <ListiniMangimiForm
              idListino={state.id}
             
              tipoListino={props.tipoListino}
              onUpdated={() => setIsChanged(true)}
              onInserted={handleInserted}
              readonly={props.readonly}
            />
          </CollapsablePanel>

          {state.id && (
            <CollapsablePanel title="Listini Mangimi Dettagli">
              <MangimiDettaglio
                listino={props.listino!}
                idListino={state.id}
                onChanged={() => setIsChanged(true)}
                readonly={props.readonly}
              />
            </CollapsablePanel>
          )}
        </>
      )}
    </Popup>
  );
};

export default React.forwardRef(PopupListino);
